import Vue from 'vue'
import App from '../App'

import { router } from '../router'
import { store } from '../store/store'
import { sync } from 'vuex-router-sync'
import { analytics } from './analytics'
import { bugsnag } from './bugsnag'
import { socket } from '../libraries/socket'

import AsyncComputed from 'vue-async-computed'
import VueLazyload from 'vue-lazyload'
import InfiniteLoading from 'vue-infinite-loading'
import GSignInButton from 'vue-google-signin-button'

import './fontawesome'
import './css'

// Import the Auth0 configuration
import { domain, clientId } from '../../auth_config.json'

// Import the plugin here
import { Auth0Plugin } from '../libraries/auth/authWrapper'

// To clean up, we can store the return value of `sync` and call it
// if we ever need to. eslint doesn't like us not using it,
// so we don't assign the variable right now.
// Documentation: https://github.com/vuejs/vuex-router-sync
sync(store, router)
Vue.use(AsyncComputed)
Vue.use(InfiniteLoading)
Vue.use(GSignInButton)
Vue.use(VueLazyload, {
  error: require('@/assets/img/OwalSquare.png'),
  loading: require('@/assets/img/OwalSquare.png'),
  attempt: 1,
})

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    )
  },
})

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App),
})

app.$mount('#app')

if (window.Cypress) {
  window.app = app
}

bugsnag(Vue)
analytics(Vue, router)
socket(store)

Vue.config.performance = process.env.NODE_ENV !== 'production'
